import { Theme } from '@theme'
import { StyleSheet } from 'react-native'

export default (theme: Theme, top: number) =>
  StyleSheet.create({
    container: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingTop: top + theme.spacing.xxl,
      paddingBottom: theme.spacing.xxxl,
    },
    topContainer: {
      flex: 1,
      width: '100%',
      alignItems: 'center',
    },
    iconApp: {
      width: 110,
      height: 110,
    },
    keeptouchTitle: {
      paddingTop: theme.spacing.lg,
      fontSize: 36,
    },
    bottomContainer: {
      flex: 1,
      width: '100%',
      alignItems: 'center',
      justifyContent: 'flex-end',
      paddingHorizontal: theme.spacing.xl,
    },
    registerButton: {
      marginVertical: theme.spacing.xl,
    },
    bottomText: {
      textAlign: 'center',
    },
  })
